
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcInputChip as ObcInputChipElement} from '@oicl/openbridge-webcomponents/dist/components/input-chip/input-chip.js';
 
 
 

 
 export const ObcInputChip = createComponent({
   react: React,
   tagName: 'obc-input-chip',
   elementClass: ObcInputChipElement,
   events: {
     
     onRemoveChip: 'remove-chip' as EventName<CustomEvent<{label: string}>>,
   }
  });
 
 